import { Observable, from, map } from "rxjs";

import { services } from "@progressive-development/pd-spa-helper";
import type { IDatabaseProvider } from "@progressive-development/pd-provider-interfaces";
import type { wahl } from "@progressive-development/politik-model";

import { COL_ERGEBNIS_SICHTEN, DB_SHARED } from "../../../config/collections.js";

/**
 * Der Dienst der Detailseite — EIN Dokument, EIN Lesevorgang.
 *
 * `ergebnis-sichten` liegt in der GETEILTEN Datenbank: Wahlergebnisse sind
 * keine Sache dieses Portals allein. Das Dokument trägt alles, was die Seite
 * zeigt — Ergebnis, Sitze, vorige Wahl —, zusammengesetzt im Export
 * (Fachkonzept 12.3). Kein Filter, kein Index, kein Zusammensuchen: Wer die
 * ID kennt, hat die Seite.
 *
 * Fehlt das Dokument, kommt `undefined` zurück — kein Fehler: Eine Adresse
 * auf eine Kombination ohne amtlichen Wert ist ein Leerzustand der Seite
 * (2.4), keine Panne.
 */
export class WahlenService {
  private get _shared(): IDatabaseProvider {
    const db = services.databaseNamed(DB_SHARED);
    if (!db) throw new Error("Keine geteilte Datenbank konfiguriert (provider-setup.ts).");
    return db;
  }

  public ladeErgebnis(id: string): Observable<WahlErgebnis> {
    return from(this._shared.getDocument<wahl.ErgebnisSicht>(COL_ERGEBNIS_SICHTEN, id)).pipe(
      map((snap) => ({ fuer: id, sicht: snap.exists ? snap.data : undefined })),
    );
  }
}

/** Das Ergebnis trägt mit, wofür es geladen wurde — gegen fremde Reste im Store. */
export interface WahlErgebnis {
  /** Die Dokument-ID `{teilwahlId}:{gebietId}`. */
  fuer: string;
  sicht?: wahl.ErgebnisSicht;
}

export const wahlenService = new WahlenService();
